var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2217_6760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 22L41.75 22.2505",
    stroke: "#98249A",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 34L34.5 34",
    stroke: "#0A70B8",
    strokeWidth: 3.75,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.7222C11.5 14.2655 11.7011 13.8274 12.0592 13.5044C12.4172 13.1814 12.9028 13 13.4091 13H32.5H51.5909C52.0972 13 52.5828 13.1814 52.9408 13.5044C53.2989 13.8274 53.5 14.2655 53.5 14.7222V40.5556C53.5 41.4691 53.0977 42.3452 52.3817 42.9911C51.6656 43.6371 50.6945 44 49.6818 44H28.6818",
    stroke: "#26BC96",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22V28.1954V40.5861V42C11.5 43.1046 12.3954 44 13.5 44H22.5",
    stroke: "#FBBF00",
    strokeWidth: 3.75,
    strokeLinecap: "square"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2217_6760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.5 11C50.7091 11 52.5 12.7909 52.5 15V42C52.5 44.2091 50.7091 46 48.5 46H30.5V35.8701H38.625C39.6605 35.8701 40.5 35.0307 40.5 33.9951C40.5 32.9596 39.6605 32.1201 38.625 32.1201H30.5V24H43.625C44.6605 24 45.5 23.1605 45.5 22.125C45.5 21.0895 44.6605 20.25 43.625 20.25H30.5V11H48.5Z",
    fill: "#6D2FEC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 36,
    width: 16,
    height: 13,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 36H46C43.6 36 42 37.1471 42 39.8235V45.1765C42 47.8529 43.6 49 46 49H54C56.4 49 58 47.8529 58 45.1765V39.8235C58 37.1471 56.4 36 54 36ZM45.4 44.4118C45.4 44.7253 45.128 44.9853 44.8 44.9853C44.472 44.9853 44.2 44.7253 44.2 44.4118V40.5882C44.2 40.2747 44.472 40.0147 44.8 40.0147C45.128 40.0147 45.4 40.2747 45.4 40.5882V44.4118ZM50 44.7941C48.672 44.7941 47.6 43.7694 47.6 42.5C47.6 41.2306 48.672 40.2059 50 40.2059C51.328 40.2059 52.4 41.2306 52.4 42.5C52.4 43.7694 51.328 44.7941 50 44.7941ZM55.8 44.4118C55.8 44.7253 55.528 44.9853 55.2 44.9853C54.872 44.9853 54.6 44.7253 54.6 44.4118V40.5882C54.6 40.2747 54.872 40.0147 55.2 40.0147C55.528 40.0147 55.8 40.2747 55.8 40.5882V44.4118Z",
    fill: "#FBBF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2217_6760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2217_6760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 60,
    fill: "white",
    transform: "translate(30.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandling);
export default __webpack_public_path__ + "static/media/Handling.ab0ae73d2215673611c80581f54f9113.svg";
export { ForwardRef as ReactComponent };